// extracted by mini-css-extract-plugin
module.exports = {"IconGroup":"BaseIconGroup_IconGroup_3z9pL","IconGroup__item":"BaseIconGroup_IconGroup__item_1zKrO"};